export const async_enabled = true;

export const cookie_expires = 30;
export const cookie_utok = 'qdb__utok';
export const cookie_lists = 'qdb__owli';
